define('viewModels/privileged/ListContainerView',[
    'lib/knockout',
    'moment',

    'services/loggingService',
    'services/userSettingsService',
    'services/intervalService',
    'viewModels/ViewModel',
    'viewModels/widgets/MediaTypePickerView',

    'extensions/i18n/knockout.i18n'
], function (
    ko,
    moment,

    log,
    userSettingsService,
    intervalService,

    ViewModel,
    MediaTypePickerView
) {
    'use strict';

    var CARD_LAYOUT_KEY  = "card";
    var TABLE_LAYOUT_KEY = "table";
    var SETTINGS_NAMESPACE = "ListContainerViewSettings";
    var LAYOUT_SETTING_KEY = "selectedLayout";

    var ListContainerView = ViewModel.extend(function () {

        var self = this;

        // ===============================================================================
        // Attributes
        // ===============================================================================

        self.listView = ko.observable();

        // ===============================================================================
        // Template Data
        // ===============================================================================


        self.intervalLabel = ko.observable();

        self.isLoadingSettings = ko.observable(true);

        //
        // Media Type
        //

        self.mediaTypePickerView = self.subView(MediaTypePickerView);

        self.computed(function () {
            if (self.listView()) {
                self.listView().mediaType(self.mediaTypePickerView.selectedMediaTypeValue());
            }
        });

        //
        // Filtering
        //

        self.filterInputLabel = self.computed(function () {
            if (self.listView()) {
                return ko.i18n.renderString(self.listView().filterInputLabel());
            }

            return "";
        });

        self.isFilterInputFocused = ko.observable(true);

        self.filterQueryValue = ko.observable("");

        self.computed(function () {
            if (self.listView()) {
                self.listView().filterList(self.filterQueryValue());
            }
        });

        //
        // Layout Switching
        //
        self.shouldDisplayLayoutToggle = ko.observable(true);

        self.isSelectingLayout = ko.observable(false); // determine if the layout dropdown is shown
        self.selectedLayout = self.computed({
            read: function () {
                if (self.listView()) {
                    return self.listView().selectedLayout();
                }
            },
            write: function (value) {
                if (self.listView()) {
                    self.listView().selectedLayout(value);
                }
            }
        });

        self.selectedLayoutObj = self.computed(function () {
            var iconMap = {};

            iconMap[CARD_LAYOUT_KEY] = {
                "icon": "fa fa-th-large",
                "messageKey": "listContainerView.cardView"
            };

            iconMap[TABLE_LAYOUT_KEY] = {
                "icon": "fa fa-align-justify",
                "messageKey": "listContainerView.tableView"
            };

            return iconMap[self.selectedLayout()];
        });

        // ===============================================================================
        // Event Callbacks
        // ===============================================================================

        //
        // Layout Selection
        //
        self.selectCardView = function () {
            self.selectedLayout(CARD_LAYOUT_KEY);
            updateLayoutSettings();
            self.isSelectingLayout(false);
        };

        self.selectTableView = function () {
            self.selectedLayout(TABLE_LAYOUT_KEY);
            updateLayoutSettings();
            self.isSelectingLayout(false);
        };

        // ===============================================================================
        // Load backend data
        // ===============================================================================

        self.computed(function () {
            var startDate = moment(intervalService.currentInterval().split("/")[0]).toDate();
            var endDate = moment(intervalService.currentInterval().split("/")[1]).toDate();
            self.intervalLabel(ko.i18n.renderString("statblock.intervals.intervalDate", {
                startTime: ko.i18n.formatDate(startDate, "LT"),
                endTime: ko.i18n.formatDate(endDate, "LT")
            }));
        });

        self.computed(function () {
            if (self.listView()) {
                self.isLoadingSettings(true);

                userSettingsService.getSettings().then(function (settings) {
                    var selectedLayout = getSelectedLayout(settings);

                    if (selectedLayout) {
                        self.selectedLayout(selectedLayout);
                    } else {
                        updateLayoutSettings();
                    }
                })
                .finally(function () {
                    self.isLoadingSettings(false);
                });
            }
        });

        // ===============================================================================
        // Util Methods
        // ===============================================================================

        /**
         * Update the selected layout saved to the backend with the value stored in the listView.
         */
        var updateLayoutSettings = function () {
            if (self.listView()) {
                var newSettings = {};
                newSettings[SETTINGS_NAMESPACE] = {};
                newSettings[SETTINGS_NAMESPACE][self.listView().settingsKey()] = {};
                newSettings[SETTINGS_NAMESPACE][self.listView().settingsKey()][LAYOUT_SETTING_KEY] = self.listView().selectedLayout();

                userSettingsService.setSettings(newSettings).catch(function (e) {
                    log.error("Failed to update the user's layout setting", e);
                });
            }
        };

        /**
         * Get the selected layout stored in the settings object returned from userSettingsService.getSettings()
         */
        var getSelectedLayout = function (settings) {
            if (settings[SETTINGS_NAMESPACE] && settings[SETTINGS_NAMESPACE][self.listView().settingsKey()]) {
                return settings[SETTINGS_NAMESPACE][self.listView().settingsKey()][LAYOUT_SETTING_KEY];
            }

            return undefined;
        };

    });

    // Expose these keys constants on the ListContainerView so views contained in this
    // container can utilize a common definition of the key's value.
    ListContainerView.CARD_LAYOUT_KEY = CARD_LAYOUT_KEY;
    ListContainerView.TABLE_LAYOUT_KEY = TABLE_LAYOUT_KEY;

    return ListContainerView;
});

